import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTechnicalKnowledgeBased = createAsyncThunk('/GetFrequentlyAskedQuestionsCatalog', async () => {
    const response = await axios.get('/GetFrequentlyAskedQuestionsCatalog');
    return response.data;
  });

const technicalKnowledgeBasedSlice = createSlice({
  name: 'technicalKnowledgeBased',
  initialState: {
    loading: false,
    error: '',
    TechnicalKnowledgeBasedData:[],
  },
  reducers: {
  },
  extraReducers: {  
    [getTechnicalKnowledgeBased.pending]: (state) => {
        state.loading = true;
      },
      [getTechnicalKnowledgeBased.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getTechnicalKnowledgeBased.fulfilled]: (state, action) => {
        state.TechnicalKnowledgeBasedData = action.payload;
        state.loading = false;
      }
  }
});
export const technicalKnowledgeBasedSliceActions = technicalKnowledgeBasedSlice.actions;
export default technicalKnowledgeBasedSlice;
